export const SET_RENTALS = 'SET_RENTALS';
export const SET_RENTAL = 'SET_RENTAL';
export const ADD_RENTAL = 'ADD_RENTAL';
export const UPDATE_RENTAL = 'UPDATE_RENTAL';
export const REMOVE_RENTAL = 'REMOVE_RENTAL';
export const CLEAR_RENTAL = 'CLEAR_RENTAL';
export const CLEAR_RENTALS = 'CLEAR_RENTALS';
